import React from "react";

import { Button } from "../../ui/button";
import { Checkbox } from "../../ui/checkbox";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { maybeReorderFieldConfig } from "../../../pages/publicPageContent";

export default function PublicFormFieldsEditor({ value, onChange }) {
  const fields = value || [];

  const updateField = (fieldKey, patch) => {
    onChange(fields.map((field) => (field.key === fieldKey ? { ...field, ...patch } : field)));
  };

  const moveField = (fieldKey, direction) => {
    onChange(maybeReorderFieldConfig(fields, fieldKey, direction));
  };

  return (
    <div className="space-y-4">
      {fields.map((field, index) => (
        <div key={field.key} className="rounded-xl border border-border/70 p-4">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="font-medium">{field.label}</div>
              <div className="text-xs text-muted-foreground">
                {field.key} {field.locked ? "· Fixfeld" : ""}
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={() => moveField(field.key, "up")}
                disabled={index === 0 || field.locked}
              >
                Hoch
              </Button>
              <Button
                type="button"
                variant="outline"
                onClick={() => moveField(field.key, "down")}
                disabled={index === fields.length - 1 || field.locked}
              >
                Runter
              </Button>
            </div>
          </div>

          <div className="mt-4 grid gap-4 md:grid-cols-2">
            <div className="space-y-2">
              <Label>Label</Label>
              <Input
                value={field.label || ""}
                onChange={(event) => updateField(field.key, { label: event.target.value })}
                disabled={field.locked}
              />
            </div>
            <div className="space-y-2">
              <Label>Placeholder</Label>
              <Input
                value={field.placeholder || ""}
                onChange={(event) => updateField(field.key, { placeholder: event.target.value })}
              />
            </div>
          </div>

          <div className="mt-4 flex flex-wrap gap-6">
            <label className="flex items-center gap-2 text-sm">
              <Checkbox
                checked={Boolean(field.visible)}
                onCheckedChange={(checked) => updateField(field.key, { visible: Boolean(checked) })}
                disabled={field.locked}
              />
              Sichtbar
            </label>
            <label className="flex items-center gap-2 text-sm">
              <Checkbox
                checked={Boolean(field.required)}
                onCheckedChange={(checked) => updateField(field.key, { required: Boolean(checked) })}
                disabled={field.locked}
              />
              Pflichtfeld
            </label>
          </div>
        </div>
      ))}
    </div>
  );
}
